import { msg } from '@lingui/macro'
import { EnhancedDomain, Model } from 'sunlife-domain'

import { isNonNullish } from '@salsita-ai/platform-common/utils'
import type { EntityId } from '@salsita-ai/platform-project-sdk/domain'

import { configuratorInterface } from '../systems/configurator-interface'

export const resetPartsOnDesignChange = configuratorInterface.transformerBuilder.when
  .entity(Model.Shorts.types)
  .modified({ atFields: ['design'] })
  .then.applySideEffect(ctx => {
    const newShorts = ctx.getNew$Entity()
    const sideEffects = newShorts.$parts
      .filter(EnhancedDomain.$PartsWithDesign.is)
      .filter(part => part.design !== newShorts.design || part.collection !== newShorts.collection)
      .map(part => {
        return configuratorInterface.updates.DomainEntityModification({
          entityId: part.id,
          stateDelta: {
            design: newShorts.design,
            collection: newShorts.collection,
          },
          updateTag: 'resetPartsOnDesignChange',
        })
      })

    if (newShorts.$drawstring.color !== newShorts.$selectedDesign.defaultDrawstringColor) {
      sideEffects.push(
        configuratorInterface.updates.DomainEntityModification({
          entityId: newShorts.$drawstring.id,
          stateDelta: {
            color: newShorts.$selectedDesign.defaultDrawstringColor,
          },
          updateTag: 'resetPartsOnDesignChange',
        })
      )
    }

    if (sideEffects.length > 0) {
      const oldShorts = ctx.getOld$Entity()
      const differingDesignPartIds = new Set<EntityId>(
        [
          ...oldShorts.$parts
            .filter(EnhancedDomain.$PartsWithDesign.is)
            .filter(part => part.design !== oldShorts.design || part.collection !== oldShorts.collection)
            .map(part => part.id),
          oldShorts.$drawstring.color !== oldShorts.$selectedDesign.defaultDrawstringColor
            ? oldShorts.$drawstring.id
            : null,
        ].filter(isNonNullish)
      )
      const resetSideEffect = sideEffects.find(sideEffect => differingDesignPartIds.has(sideEffect.entityId))
      if (resetSideEffect) {
        resetSideEffect.hint = msg`Parts with differing designs have been reset to match the new shorts design`
      }
    }

    return sideEffects
  })
  .build('resetPartsOnDesignChange')
